module.exports = __webpack_public_path__ + "static/media/caret-blue-right.5d2520fc.svg";